<div class="header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
<span>Partial Waive-off</span>
<button mat-icon-button mat-dialog-close aria-label="Close dialog" style="background-color: rgba(0, 0, 0, 0);" class="custom-mat-field">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="partialDisplay">      
    <p><strong>Original: </strong>{{totalBalance}} + {{totalLegalFee}} = {{originalLoanAmount | currency}}</p> 
    <div style="display: flex; flex-direction: row; gap:0.5em;">  
        <mat-form-field appearance="outline" style="width: 40%;" class="custom-mat-field">
            <mat-label>Partial Fee(%)</mat-label>
            <input type="number" min="1" max="100" matInput [formControl]="partialRate" (keydown)="preventDecimal($event)" step="1">
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="partialRate.invalid || isLoading" (click)="previewPartial()" style="width: 20%;">
            View          
        </button>
    </div>
    <div *ngIf="!previewData" style="display: flex; justify-content: center;align-items: center; height: 30vh;">
        <mat-spinner *ngIf="isLoading" [diameter]="50"></mat-spinner>
        <p *ngIf="!isLoading">NO DATA</p>         
    </div>
    <div *ngIf="previewData">
        <p><strong>New: </strong>{{totalBalance}} + {{partialAppliedFee}} = {{newLoanAmount | currency}}</p> 
        <table>
            <th *ngFor="let header of tableHeaders">{{header}}</th>
            <tbody>
                <tr>
                    <td>Monthly</td>
                    <td>{{ previewData.Amortization_Interest_Monthly | currency}}</td>
                    <td>{{ previewData.LPP_Monthly | currency}}</td>
                    <td>{{ previewData.Payment_Amount_Insurance_Monthly | currency}}</td>
                </tr>
                <tr>
                    <td>Bi-weekly</td>
                    <td>{{ previewData.Amortization_Interest_Biweekly | currency}}</td>
                    <td>{{ previewData.LPP_Biweekly | currency}}</td>
                    <td>{{ previewData.Payment_Amount_Insurance_Biweekly | currency}}</td>
                </tr>
                <tr>
                    <td>Weekly</td>
                    <td>{{ previewData.Amortization_Interest_Weekly | currency}}</td>
                    <td>{{ previewData.LPP_Weekly | currency}}</td>
                    <td>{{ previewData.Payment_Amount_Insurance_Weekly | currency}}</td>
                </tr>
                <tr>
                    <td>Semi-monthly</td>
                    <td>{{ previewData.Amortization_Interest_SemiMonthly | currency}}</td>
                    <td>{{ previewData.LPP_SemiMonthly | currency}}</td>
                    <td>{{ previewData.Payment_Amount_Insurance_SemiMonthly | currency}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="previewData">
        <mat-form-field appearance="outline" style="width: 40%; margin-top: 20px" class="custom-mat-field">
        <mat-label>File Type</mat-label>
            <mat-select [formControl]="fileType">
                <mat-option *ngFor="let type of fileTypes"
                [value]="type">{{type}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div *ngIf="previewData" style="display: flex; flex-direction: row; gap:0.5em; justify-items: end;">
        <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Requested Reason</mat-label>   
            <textarea matInput [formControl]="partialReason" rows="3"></textarea>  
        </mat-form-field>
        <mat-dialog-actions align="end">
            <button mat-raised-button color="primary" (click)="requestPartialWaiveOff('Partial')" [disabled]="partialRate.invalid || fileType.invalid || partialReason.invalid">Request</button>
        </mat-dialog-actions>
    </div>
</div>